import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import 'react-toastify/dist/ReactToastify.css';
import Grid from '@mui/material/Grid2';
import { toast } from 'react-toastify';
import Checkbox from '@mui/material/Checkbox';
import instance from '../../Utils/api';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


const User_address = ({ openDialog, setOpenDialog, FetchAddress }) => {
    const [data, setData] = useState({
        name: "",
        mobile: "",
        state: "",
        city: "",
        line_1: "",
        line_2: "",
        landmark: "",
        pincode: "",
        address_type: "",
        default: false,
    });


    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    }
    const handleEmpty = () => {
        setData({
            name: "",
            mobile: "",
            state: "",
            city: "",
            line_1: "",
            line_2: "",
            landmark: "",
            pincode: "",
            address_type: ""
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            !data.name || !data.mobile || !data.state ||
            !data.city || !data.line_1 || !data.line_2 || !data.landmark ||
            !data.pincode || !data.address_type
        ) {
            return toast.error("Please fill all required fields");
        }

        if (data.mobile.length < 10) {
            return toast.error("Please enter valid Mobile Number");
        }
        try {
            const response = await instance.post(`/Address/addAddress`, data);
            if (response.data.success === true) {
                toast.success(response.data.message);
                handleEmpty();
                setOpenDialog(false);
                FetchAddress();
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    }

    const handleClose = () => {
        setOpenDialog(false);
    };
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={() => setOpenDialog(false)}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Add Address
                    <Typography>
                        Add Address to place an order.
                    </Typography>
                </DialogTitle>
                <hr style={{ margin: "10px 0px" }} />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-admin">
                        <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Enter your full name'
                                        label='Full name'
                                        type='text'
                                        name='name'
                                        onChange={handleChange}
                                        value={data?.name}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder="Enter your mobile number"
                                        label="Mobile number"
                                        type="text"
                                        name="mobile"
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9]/g, ""); // Filter out non-numeric characters
                                            if (onlyNums.length <= 10) { // Limit input to 10 digits
                                                handleChange({ target: { name: 'mobile', value: onlyNums } });
                                            }
                                        }}
                                        value={data?.mobile}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Enter Your State'
                                        label='State'
                                        type='text'
                                        name='state'
                                        onChange={handleChange}
                                        value={data?.state}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Flat, House no, Building'
                                        label='Address 1'
                                        type='text'
                                        name='line_1'
                                        onChange={handleChange}
                                        value={data?.line_1}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Area, Street, Sector, Village'
                                        label='Address 2'
                                        type='text'
                                        name='line_2'
                                        onChange={handleChange}
                                        value={data?.line_2}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Enter Your Landmark'
                                        label='Landmark'
                                        type='text'
                                        name='landmark'
                                        onChange={handleChange}
                                        value={data?.landmark}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Enter Your Town/City'
                                        label='Town/City'
                                        type='text'
                                        name='city'
                                        onChange={handleChange}
                                        value={data?.city}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Enter Your Pincode'
                                        label='Pincode'
                                        type='text'
                                        name='pincode'
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                                            if (onlyNums.length <= 6) {
                                                handleChange({ target: { name: 'pincode', value: onlyNums } });
                                            }
                                        }}
                                        value={data?.pincode}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                                <div className='admin-textfiled'>
                                    <TextField
                                        placeholder='Enter Your Address Type'
                                        label='Address Type'
                                        type='text'
                                        name='address_type'
                                        onChange={handleChange}
                                        value={data?.address_type}
                                        fullWidth
                                        required
                                    />
                                </div>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10 }} sx={{ display: 'flex', alignItems: 'center' }} gap='6px' >
                                <div className='default_address'>
                                    <Checkbox
                                        {...label}
                                        checked={data?.default}
                                        onChange={(e) => setData({ ...data, default: e.target.checked })}
                                        sx={{
                                            color: '#E37B00',
                                            '&.Mui-checked': {
                                                color: '#E37B00',
                                            },
                                        }}
                                    />
                                    <Typography variant='body1' >Set this as my default Address</Typography>
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose} >
                        Cancel
                    </Button>
                    <Button className="add-btn" onClick={handleSubmit} >
                        Add
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    )
}

export default User_address;